import * as React from "react";

import { Link, useParams, useNavigate } from "react-router-dom";
import { RiArrowLeftLine } from "react-icons/ri";

import Dropzone from "../../Components/Dropzone";
import Button from "../../Components/Button";
import Paper from "../../Components/Paper";

import axiosInstance from "../../Api/Axios";
import { useToast } from "../../Context/ToastContext";
import { useLoader } from "../../Context/LoaderContext";

import "./CommitementPdf.scss";

const initialFormState = {
  commitment_pdf: [],
};

const CommitementPdf = () => {
  const [valRegister, setValRegister] = React.useState(initialFormState);
  const [formErrorMessages, setFormErrorMessages] = React.useState("");

  const navigate = useNavigate();

  const { addToast } = useToast();
  const { setIsLoading } = useLoader();
  const { id } = useParams();

  const handleChangeField = (val, key) => {
    setFormErrorMessages((prev) => ({
      ...prev,
      [key]: "",
    }));

    setValRegister((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    const formData = new FormData();

    formData.append("commitment_pdf", valRegister.commitment_pdf[0] || []);

    axiosInstance
      .post(
        `${process.env.REACT_APP_API_URL}/change-insurance-requests/update/${id}`,
        formData
      )
      .then((response) => {
        setIsLoading(false);

        if (response.data.status) {
          addToast({
            variant: "success",
            message: response.data.message,
          });
          navigate("/list-insurance-requests");
        }
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response.data.errors) {
          setFormErrorMessages(error.response.data.errors);
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        }
      });
  };

  return (
    <>
      <div className="back-home">
        <Link to="/list-insurance-requests" className="link-back">
          <RiArrowLeftLine />
        </Link>
      </div>
      <h1>Engagement</h1>
      <p>Veuillez remplir le champs ci dessous</p>
      <Paper>
        <form className="register-form" onSubmit={handleSubmit} noValidate>
          <Dropzone
            label="Engagement"
            name="commitment_pdf"
            hasError={formErrorMessages.commitment_pdf}
            errorMessage={
              <div className="text-danger">
                {formErrorMessages.commitment_pdf}
              </div>
            }
            value={valRegister.commitment_pdf || []}
            onChange={(files) => handleChangeField(files, "commitment_pdf")}
            required
            accept="image/*,.pdf"
            description={
              <>
                Cette dropzone accepte les fichiers de type
                <b> png, jpg, jpeg, pdf</b>
              </>
            }
          />

          <div className="wrap_actions_form">
            <Button type="submit" size="lg">
              Envoyer
            </Button>
          </div>
        </form>
      </Paper>
    </>
  );
};

export default CommitementPdf;
